module.exports = __webpack_public_path__ + "ea37ab2abb3eaf92d1914ea5fbed39cc.ttf";


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/fonts/Alegreya-Italic.ttf
// module id = 16
// module chunks = 0